import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { TabContext, TabList, TabPanel } from '@mui/lab'
import { Tab } from '@mui/material'
import { Box } from '@mui/material'
import ColorBox from 'common/Box/ColorWhiteBox'
import PageLayoutV2 from 'common/Layout/Page/PageLayoutV2'

import FaberFinanceTable from './components/FaberFinanceTable'
import FaberRefundRequests from './components/FaberRefundRequests'

export default function FaberFinanceMainDashboard() {
  const [tabValue, setTabValue] = useState('1')
  const handleTabChange = (event, newNum) => setTabValue(newNum)

  return (
    <PageLayoutV2 header='Finance - Faber'>
      <TabContext value={tabValue}>
        <TabList onChange={handleTabChange} aria-label='lab API tabs example'>
          <Tab label='Dashboard' value='1' component={Link} to='#dashboard' />
          <Tab
            label='Refund Requests'
            value='2'
            component={Link}
            to='#refund-requests'
          />
        </TabList>

        <TabPanel value='1'>
          <ColorBox>
            <Box>
              <FaberFinanceTable />
            </Box>
          </ColorBox>
        </TabPanel>
        <TabPanel value='2'>
          <ColorBox>
            <Box>
              <FaberRefundRequests />
            </Box>
          </ColorBox>
        </TabPanel>
      </TabContext>
    </PageLayoutV2>
  )
}
